import { useState, useEffect } from 'react';
import {
  Badge,
  Chip,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  styled,
} from '@mui/material';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import { getHistoryListApi } from '../../redux/slice/userSlice';
import styles from '../../assets/styles/history';
import { ClassNames } from '@emotion/react';
import CustomButton from '../../components/Button/button';
import noData from '../../assets/images/rfdd.png';
const items = [
  {
    payfrequency: 'monthly',
    date: '31-12-2020',
    netpaid: 22110,
    grossamount: 37110,
    tax: 15000,
    enteredField: 'Gross',
    id: 1,
  },
  {
    payfrequency: 'yearly',
    date: '25-12-2020',
    netpaid: 693836,
    grossamount: 1253836,
    tax: 560000,
    enteredField: 'Net Amount',
    id: 2,
  },
  {
    payfrequency: 'weekly',
    date: '31-06-2020',
    netpaid: 50000,
    grossamount: 93276,
    tax: 43276,
    enteredField: 'Tax Withheld',
    id: 3,
  },
  {
    payfrequency: 'quarterly',
    date: '31-05-2020',
    netpaid: 356102,
    grossamount: 658068,
    tax: 301966,
    enteredField: 'Gross',
    id: 4,
  },
  {
    payfrequency: 'fortnightly',
    date: '31-04-2020',
    netpaid: 27627,
    grossamount: 50000,
    tax: 22373,
    enteredField: 'Net Amount',
    id: 5,
  },
  {
    payfrequency: 'monthly',
    date: '31-03-2020',
    netpaid: 123456,
    grossamount: 228328,
    tax: 104873,
    enteredField: 'Tax Withheld',
    id: 6,
  },
  {
    payfrequency: 'yearly',
    date: '31-02-2020',
    netpaid: 400303,
    grossamount: 700000,
    tax: 299697,
    enteredField: 'Gross',
    id: 7,
  },
  {
    payfrequency: 'fortnightly',
    date: '31-01-2020',
    netpaid: 372127,
    grossamount: 700000,
    tax: 327873,
    enteredField: 'Gross',
    id: 8,
  },
];

const TableHeading = styled(TableCell)(() => ({
  fontFamily: 'inherit',
  fontSize: '13px',
}));

export default function StickyHeadTable(props: any) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const classes = styles();

  const historyDetailsList = useSelector(
    (state: any) => state.user.historyListData
  );

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
    // dispatch(getHistoryListApi({ navigate, rowsPerPage, page: newPage }));
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
    // dispatch(
    // 	getHistoryListApi({ navigate, rowsPerPage: +event.target.value, page: 0 })
    // );
  };

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [historyDetailsList]);

  return (
    <>
      {items.length > 0 ? (
        <Paper sx={{ width: '100%', overflow: 'hidden', marginTop: 2 }}>
          <>
            <div style={{ marginLeft: 16 }}>
              <h2 style={{ marginBottom: 0 }}>{'History'}</h2>
            </div>
            <div className={classes.tableClass}>
              <Table className={classes.tableContainer}>
                <TableHead>
                  <TableRow className={classes.headingContainer}>
                    <TableHeading align='left' className={classes.Heading}>
                      Date
                    </TableHeading>
                    <TableHeading align='left' className={classes.Heading}>
                      Entered Amount
                    </TableHeading>
                    <TableHeading align='left' className={classes.Heading}>
                      Pay Frequency
                    </TableHeading>
                    <TableHeading align='left' className={classes.Heading}>
                      Gross Amount
                    </TableHeading>
                    <TableHeading align='left' className={classes.Heading}>
                      Net Amount
                    </TableHeading>
                    <TableHeading align='left' className={classes.Heading}>
                      Tax Amount
                    </TableHeading>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {items.length > 0 &&
                    items?.map((history: any) => {
                      return (
                        <TableRow hover key={history._id}>
                          <TableCell align='left'>
                            <div>{history.date}</div>
                            {/* <div>{history.updatedAt.split(',')[0]}</div> */}
                            {/* <div className={classes.secondaryTime}>
                              {history.updatedAt.split(',')[1]}
                            </div> */}
                          </TableCell>
                          <TableCell align='left'>
                            <Chip
                              color='primary'
                              label={history.enteredField}
                              size='small'
                              className={classes.ChipStyles}
                            />
                            {/* {history.enteredField} */}
                          </TableCell>
                          <TableCell align='left'>
                            {history.payfrequency[0].toUpperCase() +
                              history.payfrequency.slice(1)}
                          </TableCell>
                          <TableCell align='left'>
                            {history.grossamount}
                          </TableCell>
                          <TableCell align='left'>{history.netpaid}</TableCell>
                          <TableCell align='left'>{history.tax}</TableCell>
                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>
            </div>
            {/* <TablePagination
              rowsPerPageOptions={[5, 10, 15]}
              component='div'
              count={historyDetailsList?.totalCount}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            /> */}
          </>
        </Paper>
      ) : (
        <div className={classes.container}>
          <Paper className={classes.NoresultsPaper}>
            <div className={classes.noResultsClass}>
              <div className={classes.noResultContainer}>
                <img src={noData} alt='no data' className={classes.imgClass} />
                <h2>No History Found</h2>
                <CustomButton onClick={props.handleBackButton}>
                  Back to Calculation
                </CustomButton>
              </div>
            </div>
          </Paper>
        </div>
      )}
    </>
  );
}
